<template>
  <div style="display: flex" v-if="(notification.dataList && notification.dataList.length) ||  !isEmpty">
    <a-popover
      placement="bottomRight"
      overlayClassName="news-popover-overlay entry-head-drop-overlay"
      :trigger="['hover']"
      arrowPointAtCenter
    >
      <span class="right-content__action">
        <a-badge
          :count="notification.noReadCount"
          :overflow-count="maxCount"
          :offset="[(`${notification.noReadCount > maxCount ? (maxCount + 1) : notification.noReadCount}`.length - 1) * 2, 0]"
          :number-style="{
            height: '16px',
            lineHeight: '16px',
            fontSize: '12px',
            padding: '0 5px',
            boxShadow: '0 0 0 1px transparent',
          }"
        >
          <a href="javascript:;">
            <icon-font class="icon" type="gb-icon-lingdang" />
          </a>
        </a-badge>
      </span>
      <div slot="content" class="news-menu">
        <div class="news-menu-title">
          <span>{{langCodeLabels[currentLang].title }}</span>
          <span @click="handleNotips" :style="statusStyle">{{langCodeLabels[currentLang].status }}</span>
        </div>
        <div v-if="notification.dataList">
          <div class="news-menu-item" v-for="(item, index) in notification.dataList" :key="index"  @click="toDetails(item)">
            <div class="news-menu-item-top">
              <div class="news-menu-item-top__label" v-if="msgTypeList[item.msgType]">{{ msgTypeList[item.msgType][langCodes[currentLang]] }}</div>
              <div class="news-menu-item-top__time">
                <a-icon type="clock-circle" style="margin-right:3px; font-size: 12px; color:#444444" />
                {{moment(item.sendTime || item.createTime).format('YYYY-MM-DD HH:mm:ss')}}
              </div>
            </div>
            <div class="news-menu-item-info" :title="item.msgTitle">
              {{item.msgTitle}}
            </div>
          </div>
        </div>
        <div class="empty-list" v-else>
          <img src="@/assets/interface _authorization_no-data.png" alt="">
          <p>{{$t('empty_data')}}</p>
        </div>
        <div class="news-menu-more">
          <a-button type="link" style="font-size: 12px" @click="toDetails()">
            {{langCodeLabels[currentLang].more }}
          </a-button>
        </div>
      </div>
    </a-popover>
    <span style="display:inline-flex; max-width: 20px; opacity: 0" >{{ notification.noReadCount }}</span>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { SaveAllRead } from '@/api/sso/menu'

export default {
  data () {
    return {
      langCodes: {
        en_US: 'en',
        zh_CN: 'cn',
        ko_KR: 'kr'
      },
      langCodeLabels: {
        zh_CN: {
          more: '查看更多 >',
          title: '消息通知',
          status: '全部已读'
        },
        en_US: {
          more: 'View more >',
          title: 'Notification',
          status: 'Have read'
        },
        ko_KR: {
          more: '더보기 >',
          title: '공고',
          status: '모두 읽음'
        }
      },
      maxCount: 99,
      isEmpty: true
    }
  },
  computed: {
    ...mapGetters([
      'currentLang',
      'notification',
      'messageClassification'
    ]),
    msgTypeList () {
      return this.messageClassification.reduce((acc, { classificationName, classificationKrName, classificationEnName, messageType }) => {
        return {
          ...acc,
          [messageType]: {
            cn: classificationName,
            kr: classificationKrName,
            en: classificationEnName
          }
        }
      }, {})
    },
    statusStyle () {
      if (this.notification.noReadCount === 0) {
        return {
          color: 'rgba(0,0,0, 0.25)',
          cursor: 'pointer',
          pointerEvents: 'none'
        }
      } else {
        return {
          color: '#006EFF',
          cursor: 'pointer'
        }
      }
    }
  },
  methods: {
    moment,
    toDetails (row) {
      let id = ``
      if (row?.id) {
        id = `?id=${row.id}`
      }
      const { params: { serviceId, systemCode } } = this.$route
      this.$store.dispatch('entry/SetActiveAsync', {
        path: `/entry/${serviceId}/${systemCode}/sso-web#/company/notice/notification${id}`
      })
      setTimeout(() => {
        this.$store.dispatch('queryMsgNoticePage')
      }, 100)
    },
    /**
     * 全部已读
     */
    handleNotips () {
      SaveAllRead({}).then((res) => {
        if (res.code === '200') {
          this.isEmpty = false
          this.$store.dispatch('queryMsgNoticePage')
        }
      })
    }
  },
  mounted () {
    this.$store.dispatch('queryMsgNoticePage')
  }
}
</script>

<style lang="less">
.news-popover-overlay {
  .@{ant-prefix}-popover-inner {
    padding: 0;
    min-width: 200px;
    // margin-top: -1px !important;
  }
  .@{ant-prefix}-menu-submenu-arrow {
    display: none;
  }
}
</style>

<style lang="less" scoped>
.right-content__action {
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/.@{ant-prefix}-badge {
  font-size: 16px;
  a {
    color: #fff;
  }
  &:hover a {
    color: #1890ff;
  }
}
.news-menu {
  position: relative;
  width: 335px;
  min-height: 50px;
  background: #fff;
  // box-shadow: 0px 0px 51px 3px rgba(0, 21, 41, 0.11);
  border-radius: 4px;
  &-title {
    display: flex;
    justify-content:space-between;
    line-height: 42px;
    padding: 0 17px;
    font-size: 14px;
    border-bottom: 1px solid #ECECEC;
  }
  &-item {
    padding: 0 17px 14px 17px;
    width: auto;
    border-bottom: 1px solid #ECECEC;
    font-size: 12px;
    &-top {
      display: flex;
      justify-content: space-between;
      padding: 10px 0;
      line-height: 1;
      & * {
        display: inline-flex;
        align-self: center
      }
      &__label {
        display: inline-block;
        padding: 5px 9px;
        background: #E6F0FE;;
        border: 1px solid #CCE2FE;
        border-radius: 2px;
        color: #333333;
        max-width: 140px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    &-info {
      line-height: 18px;
      color: #006EFF;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      &:hover {
        opacity: 0.8;
      }
    }
    &:hover {
      background: rgba(0, 110, 255, 0.05);
      cursor: pointer;
    }
  }
  &-more {
    line-height: 34px;
    padding: 0 17px 0 0;
  }
  .empty-list {
    width: 200px;
    padding: 60px 0;
    position: relative;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    text-align: center;
    img {
      width: 135px;
      height: 113px;
    }
    p {
      margin-top: 7px;
      color: #999999;
      font-size: 12px;
    }
  }
}
</style>
